export enum TileMode {
  Full,
  Compact,
}
